import { registerAction } from '../../Action'

const SET_CURRENT_STORY = 'SET_CURRENT_STORY'

const reducer = (state = {}, action) => ({
  ...state,
  currentStoryId: action.payload,
})

const setActiveStory = registerAction(SET_CURRENT_STORY, { reducer })

const setCurrentStory = (storyId) => (dispatch) => {
  dispatch(setActiveStory(storyId))
}

export default setCurrentStory
